import React, { FC } from "react";

import Link from "next/link";

interface NavItemProps {
  label: string;
  link: string;
}

const NavItem: FC<NavItemProps> = ({ link, label }) => {
  return (
    <div className="mx-4 relative flex align-center">
      <Link
        href={link}
        className="relative font-normal
        after:relative after:transition-all after:content-[''] after:block after:bg-highlight after:rounded-2xl after:h-1 after:bottom-px after:left-0 after:w-0 after:transition-all after:duration-300 after:ease-out hover:after:w-full"
      >
        {label}
      </Link>
    </div>
  );
};

export default NavItem;
